<template>
  <div class="form-resolve">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          {{ $t('contacts.comment.form_resolve.title') }}
        </p>
      </div>
      <div class="last-message" v-if="lastMessage">
        <div class="child">
          <p id="idLineContact" ref="idLineContact" class="whitespace-pre-line" :class="showAll ? '' : 'not-show-all'" v-html="lastMessage"></p>
          <span v-if="showLine>3" class="btn-show" @click="handleShowLastMessage">
            {{ showAll ? '▲' + $t('contacts.not_show_all') : '▼' + $t('contacts.show_all') }}
          </span>
        </div>
      </div>
      <div class="footer">
        <el-button type="primary" @click="resolve" class="btn btn-send">{{ $t('contacts.comment.form_resolve.btn_resolve') }}</el-button>
        <el-button type="primary" @click="back" class="btn btn-back">{{ $t('contacts.comment.form_resolve.btn_cancle') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { resolveContact } from '../../api/contact'

  export default {
    props: {
      openDialogResolveContact: { type: Boolean, required: true, default: false },
      urls: { type: Object, required: true, default: {} },
      lastMessage: { type: String, required: true, default: '' },
    },
    emits: ['closePopupResolve', 'resolveComplete'],
    data() {
      return {
        dialog: false,
        loading: false,
        showAll: false,
        showLine: 0,
      };
    },
    methods: {
      handleClose() {
        this.$emit('closePopupResolve');
      },
      resolve() {
        document.querySelector(".el-dialog__body").classList.add("disabled");
        resolveContact(this.urls.resolve)
        .then(response => response.json())
        .then(response => {
          if (response.status_code === this.$httpStatus.success) {
            this.$emit('resolveComplete', response.data.status_label);
          }
        })
      },

      back() {
        this.handleClose();
      },

      handleShowLastMessage() {
        this.showAll = !this.showAll;
      }
    },
    created() {
      this.dialog = this.openDialogResolveContact;
    },
    mounted(){
      this.$nextTick(()=>{
        this.showLine = Math.floor((this.$refs.idLineContact.scrollHeight)/28);
      });
    }
  }
</script>

<style lang="scss" scoped>
  .form-resolve {
    text-align: center !important;
    .title {
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      font-weight: 700
    }
    .last-message {
      padding: 0 48px;
      .child {
        width: 100%;
        margin: 12px auto 24px;
        text-align: left;
        border-left: solid 1px #DDD8D1;
        color: #000000;
        .not-show-all {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin: 0;
        }
        p {
          font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          line-height: 28px;
          padding-left: 15px;
          margin: 0;
          color: #000;
          max-height: 300px;
          overflow-y: scroll;
          &::-webkit-scrollbar {
            width: 0;
            background: transparent;
          }
        }
        .btn-show {
          color: #17609F;
          cursor: pointer;
          padding-top: 6px;
          display: inline-block;
          margin-left: 15px;
          letter-spacing: 1.3px;
        }
      }
    }
    .main {
      width: 80%;
      margin: 25px auto;
      background: #F7F3ED 0% 0% no-repeat padding-box;
      letter-spacing: 0.75px;
      color: #000000;
      padding: 25px;
      text-align: left;
      .message {
        border-right: solid 1px #DDD8D1;
      }
    }
    .footer {
      margin-top: 30px;
      .btn {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 250px;
        height: 50px;
        border-radius: 25px !important;
        margin-left: 25px;
        &:first-child {
          margin-left: 0;
        }
      }
      .btn-send {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
      }
      .btn-back {
        background: #969696 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #969696;
        --el-button-hover-border-color: #969696;
        --el-button-border-color: #969696;
      }
    }
  }
</style>
